module.exports = __webpack_public_path__ + "assets/webgl/Frame_Ornament_materialParams.1001.jpg.etc.23a28c55.ktx";